/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="13.62"
        viewBox="0 0 19 13.62"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M17.5 0H3.35v5.35H0v8.27h5.8v-3.35h4.09v2.33H6.81v1h7.18v-1h-3.1v-2.33h4.16v3.31H19v-6.8h-1.5ZM4.8 12.62H1v-.95h3.8Zm0-1.95H1V6.35h3.8Zm10.25-1.4H5.8v-1h9.25Zm0-2H5.8v-2H4.35V1H16.5v5.78h-1.45ZM18 12.54h-1.95v-.91H18Zm0-4.8v2.89h-1.95V7.74h1.45Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'DevicesIcon';

export default Icon;
